import { render } from "./VehicleInspectionRequest.vue?vue&type=template&id=2fc7a423&scoped=true&ts=true"
import script from "./VehicleInspectionRequest.vue?vue&type=script&lang=ts"
export * from "./VehicleInspectionRequest.vue?vue&type=script&lang=ts"

import "./VehicleInspectionRequest.vue?vue&type=style&index=0&id=2fc7a423&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc7a423"]])

export default __exports__